/** Shared Tailwind classes for project catalog editors */
export const inp =
  'marreq-catalog-field w-full text-sm bg-stitch-elevated border border-stitch-border rounded-md px-2 py-2 text-stitch-fg placeholder:text-stitch-muted focus:border-stitch-accent focus:ring-1 focus:ring-stitch-accent/40 outline-hidden disabled:opacity-45';
export const btnPrimary =
  'bg-stitch-accent text-stitch-canvas px-4 py-2 rounded-md text-xs font-bold uppercase tracking-wider disabled:opacity-40';
export const btnDanger =
  'text-red-400 hover:text-red-300 text-xs font-bold uppercase disabled:opacity-40';
